import { ImportedBookRecord } from './types'

export const mockImportedRecords: ImportedBookRecord[] = [
  {
    id: 'rec-1',
    title: 'The Silent Echo',
    authorName: 'Elena Richards',
    isbn13: '9781234567890',
    myRating: 5,
    dateRead: '2023/10/15',
    bookshelves: ['read', 'favorites', 'fantasy'],
    genre: 'Fantasy',
    seriesStatus: 'Book 1 of Echo Chronicles',
    myReview: 'Absolutely loved this book! The magic system was unique.',
    status: 'mapped',
    matchConfidence: 100,
    afterTideBookId: 'b1',
    coverUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200',
  },
  {
    id: 'rec-2',
    title: 'Beyond the Veil',
    authorName: 'Marcus Chen',
    isbn13: '9780987654321',
    myRating: 4,
    dateRead: '2023/09/20',
    bookshelves: ['read', 'sci-fi'],
    genre: 'Sci-Fi',
    seriesStatus: 'Standalone',
    status: 'mapped',
    matchConfidence: 95,
    afterTideBookId: 'b2',
    coverUrl: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200',
  },
  {
    id: 'rec-3',
    title: 'Whispers in the Dark',
    authorName: 'Sarah Johnson',
    myRating: 0,
    dateAdded: '2023/11/01',
    bookshelves: ['to-read', 'thriller'],
    genre: 'Thriller',
    seriesStatus: 'Standalone',
    status: 'pending',
    matchConfidence: 40,
  },
  {
    id: 'rec-4',
    title: 'The Memory Collector',
    authorName: 'Aiden Park',
    isbn13: '9781122334455',
    myRating: 3,
    dateRead: '2023/08/10',
    bookshelves: ['read', 'mystery'],
    genre: 'Mystery',
    seriesStatus: 'Book 2 of Memory Trilogy',
    myReview: 'Good pacing, but the ending was a bit predictable.',
    status: 'mapped',
    matchConfidence: 85,
  },
  {
    id: 'rec-5',
    title: 'Fractured Realms',
    authorName: 'Zoe Chen',
    myRating: 0,
    dateAdded: '2023/11/05',
    bookshelves: ['currently-reading', 'fantasy'],
    genre: 'Fantasy',
    seriesStatus: 'Book 1 of Realm Wars',
    status: 'pending',
    matchConfidence: 60,
    coverUrl:
      'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?w=200',
  },
]
